import "./SearchResultItem.scss";

import { Icon, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";
import { Voltage } from "types/voltageTypes";

export type SearchResult = {
    readonly text: string;
    readonly subText?: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly maybeBoundingBox?: [number, number, number, number];
    readonly id: string;
    readonly isBus?: boolean;
    readonly voltage?: Voltage;
};

type SearchResultItemProps = {
    readonly onSearchResultItemSelected: (searchResult: SearchResult) => void;
    readonly searchResult: SearchResult;
    readonly isLastItem: boolean;
    readonly isVoltageNotInFilters: boolean;
};

const SearchResultItem: React.FC<SearchResultItemProps> = (props) => {
    const {
        searchResult,
        onSearchResultItemSelected,
        isLastItem,
        isVoltageNotInFilters
    } = props;
    return (
        <div
            className={`SearchResultItem-wrapper ${
                !isLastItem ? "SearchResultItem-wrapper-not-last" : ""
            }`}
            onMouseDown={() => {
                onSearchResultItemSelected(searchResult);
            }}
        >
            <div className="SearchResultItem-content">
                <div className={`SearchResultItem-text`}>
                    <b>{searchResult.text}</b>
                </div>
                {searchResult.subText && (
                    <div className={`SearchResultItem-sub-text bp5-text-muted`}>
                        {searchResult.subText}
                    </div>
                )}
            </div>
            {isVoltageNotInFilters && (
                <Tooltip
                    content={
                        "Voltage not included in filters. Selecting this bus will add to filters."
                    }
                    placement="right"
                >
                    <Icon
                        className="SearchResultItem-icon bp5-text-muted"
                        icon={IconNames.FILTER_REMOVE}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default SearchResultItem;
